/**
 * Halvo — весь JS темы в одном файле. Модули независимы, каждый ищет свои data-атрибуты.
 *
 *  Countdown   — таймер в полоске-анонсе (data-countdown), запоминает старт в localStorage
 *  Drawer      — закрытие меню-панели кнопкой и по Esc (details[data-drawer])
 *  Gallery     — галерея товара: миниатюры, стрелки, синхронизация с прокруткой (data-gallery)
 *  ProductForm — плитки количества, подписка/разово, цена в кнопке, добавление в корзину (data-product-form)
 *  Tabs        — вкладки блока Science со стрелками (data-tabs)
 *  FaqTabs     — фильтр вопросов по категории (data-faq)
 *  CartDrawer  — выезжающая корзина: открытие, количество, допродажа (data-cart-drawer)
 *
 * Без JS всё остаётся рабочим: форма отправляется обычным POST, аккордеоны на <details>.
 */
(function () {
  'use strict';

  /* ---------- утилиты ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function formatMoney(cents, format) {
    // format — shop.money_format из Liquid, например "${{amount}}"
    var amount = (Number(cents) / 100).toFixed(2);
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, function (_, mod) {
      if (mod === '_no_decimals') return Math.round(Number(cents) / 100).toString();
      if (mod === '_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  }

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var minutes = Number(el.dataset.minutes) || 0;
    var out = $('[data-countdown-time]', el);
    if (!minutes || !out) return;
    var key = el.dataset.key || 'halvo-banner';
    var start;
    try { start = Number(localStorage.getItem(key)); } catch (e) { start = 0; }
    if (!start || Date.now() - start > minutes * 60000) {
      start = Date.now();
      try { localStorage.setItem(key, String(start)); } catch (e) { /* приватный режим */ }
    }
    function tick() {
      var left = Math.max(0, minutes * 60000 - (Date.now() - start));
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) { // по нулю — новый круг, как на референсе
        start = Date.now();
        try { localStorage.setItem(key, String(start)); } catch (e) { /* ignore */ }
      }
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Drawer ---------- */
  $$('details[data-drawer]').forEach(function (d) {
    $$('[data-drawer-close]', d).forEach(function (b) { b.addEventListener('click', function () { d.removeAttribute('open'); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') d.removeAttribute('open'); });
    d.addEventListener('toggle', function () { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    if (!track) return;
    var slides = $$('.pcar__slide', track);
    var index = 0;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); });
      var active = thumbs[index];
      if (active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.galleryThumb)); }); });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    // синхронизация миниатюр при свайпе
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) { index = i; thumbs.forEach(function (th, k) { th.classList.toggle('is-active', k === index); }); }
      }, 80);
    }, { passive: true });
  });

  /* ---------- ProductForm ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var moneyFormat = form.dataset.moneyFormat;
    var qtyInput = $('[data-quantity-input]', form);
    var planInput = $('[data-selling-plan-input]', form);
    var ctaPrice = $('[data-cta-price]', form);
    var ctaCompare = $('[data-cta-compare]', form);
    var errorEl = $('[data-form-error]', form);
    var button = $('[data-add-to-cart]', form);
    var tiles = $$('.pqty__tile', form);
    var radios = $$('input[name="purchase_option"]', form);

    function currentQty() { return Number(qtyInput && qtyInput.value) || 1; }

    function currentDiscount() {
      var t = tiles.filter(function (x) { return x.classList.contains('is-active'); })[0];
      return Number(t && t.dataset.discount) || 0;
    }
    // цена за банку с учётом скидки за количество (та же, что автоматическая скидка в Shopify)
    function unit(cents, disc) { return Math.round(Number(cents) * (100 - disc) / 100); }
    var basePrice = radios.reduce(function (m, x) { return Math.max(m, Number(x.dataset.compare) || 0, Number(x.dataset.price) || 0); }, 0);

    // Подписка: N банок = доставка раз в N месяцев, если такой план есть (иначе ежемесячный)
    var subRadio = radios.filter(function (x) { return x.dataset.plans; })[0];
    var plans = [];
    try { plans = subRadio ? JSON.parse(subRadio.dataset.plans) : []; } catch (e) { plans = []; }
    var planLabel = $('[data-plan-label]', form);
    function syncPlan(qty) {
      if (!subRadio || !plans.length) return;
      var byMonths = function (m) { return plans.filter(function (p) { return p.months === m; })[0]; };
      var p = byMonths(qty) || byMonths(1) || plans[0];
      subRadio.value = p.id;
      subRadio.dataset.price = p.price;
      if (planLabel) {
        var multi = plans.some(function (x) { return x.months > 1; });
        var tpl = planLabel.dataset.labelN;
        planLabel.textContent = multi && tpl ? tpl.replace('{n}', p.months) : planLabel.dataset.labelOne;
      }
    }

    function render() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      var qty = currentQty(), disc = currentDiscount();
      syncPlan(qty);
      if (planInput) { planInput.value = r.value; planInput.disabled = !r.value; }
      radios.forEach(function (x) {
        var box = x.closest('.ptype');
        box.classList.toggle('is-active', x.checked);
        var u = unit(x.dataset.price, disc), c = Number(x.dataset.compare) || 0;
        var priceEl = $('[data-unit-price]', box), compareEl = $('[data-unit-compare]', box);
        if (priceEl) priceEl.textContent = formatMoney(u, moneyFormat);
        if (compareEl) { compareEl.textContent = formatMoney(c, moneyFormat); compareEl.hidden = !(c > u); }
      });
      var price = unit(r.dataset.price, disc) * qty;
      var compare = (Number(r.dataset.compare) || 0) * qty;
      if (ctaPrice) ctaPrice.textContent = formatMoney(price, moneyFormat);
      if (ctaCompare) {
        if (compare > price) { ctaCompare.textContent = formatMoney(compare, moneyFormat); ctaCompare.hidden = false; }
        else ctaCompare.hidden = true;
      }
      // «SAVE X%» на плитках: от разовой цены до цены выбранного типа покупки
      tiles.forEach(function (t) {
        var el = $('[data-tile-savings]', t);
        if (!el || !basePrice) return;
        var pct = Math.round((basePrice - unit(r.dataset.price, Number(t.dataset.discount) || 0)) * 100 / basePrice);
        el.textContent = 'SAVE ' + pct + '%';
        el.style.visibility = pct > 0 ? '' : 'hidden'; // место под надписью остаётся — «1 Jar» не прыгает
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        tiles.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        tile.classList.add('is-active'); tile.setAttribute('aria-checked', 'true');
        if (qtyInput) qtyInput.value = tile.dataset.qty || 1;
        render();
      });
    });
    radios.forEach(function (r) { r.addEventListener('change', render); });
    // плитка по умолчанию задаёт количество при загрузке
    var def = tiles.filter(function (x) { return x.classList.contains('is-active'); })[0];
    if (def && qtyInput) qtyInput.value = def.dataset.qty || 1;
    render();

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !button) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      button.disabled = true;
      var html = button.innerHTML; button.textContent = 'Adding…';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.j.description || r.j.message || 'Could not add to cart');
          if (window.HalvoCart && window.HalvoCart.open) { window.HalvoCart.refresh(true); button.disabled = false; button.innerHTML = html; }
          else window.location.href = root + 'cart';
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          button.disabled = false; button.innerHTML = html;
        });
    });
  });

  /* ---------- Tabs (Science) ---------- */
  $$('[data-tabs]').forEach(function (tabs) {
    var section = tabs.closest('section') || document;
    var buttons = $$('[data-tab]', tabs);
    var panels = $$('[data-tab-panel]', section);
    var index = 0;
    function show(i) {
      index = (i + buttons.length) % buttons.length;
      buttons.forEach(function (b, k) { b.classList.toggle('is-active', k === index); b.setAttribute('aria-selected', k === index ? 'true' : 'false'); });
      panels.forEach(function (p, k) {
        p.classList.toggle('is-hidden', k !== index);
        p.querySelectorAll('video').forEach(function (v) { if (k === index) { var r = v.play && v.play(); if (r) r.catch(function () {}); } else if (v.pause) v.pause(); });
      });
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { show(Number(b.dataset.tab)); }); });
    var prev = $('[data-tabs-prev]', section), next = $('[data-tabs-next]', section);
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    // свайп пальцем по карточке
    var stage = $('.science__stage', section), x0 = null, y0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
  });

  /* ---------- AccordionMove: на мобайле «Is This For You?» стоит после блока Science (как в референсе) ---------- */
  (function () {
    var acc = $('[data-product-accordion]'), science = $('#anchor--science');
    if (!acc || !science || !window.matchMedia) return;
    var home = document.createComment('product-accordion');
    acc.parentNode.insertBefore(home, acc);
    var mq = window.matchMedia('(max-width: 1024px)');
    function place() {
      if (mq.matches) { science.insertAdjacentElement('afterend', acc); acc.classList.add('pacc--moved'); }
      else { home.parentNode.insertBefore(acc, home.nextSibling); acc.classList.remove('pacc--moved'); }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  })();

  /* ---------- FaqTabs ---------- */
  $$('[data-faq]').forEach(function (faq) {
    var tabs = $$('[data-faq-tab]', faq), items = $$('[data-faq-item]', faq);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        items.forEach(function (it) { it.hidden = it.dataset.faqItem !== t.dataset.faqTab; });
      });
    });
  });
})();

/* ---------- SpinToWin (sections/spin-to-win.liquid) ---------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-spin]');
  if (!root) return;
  var key = root.dataset.key || 'halvo-spin';
  var days = Number(root.dataset.days) || 14;
  var delay = Number(root.dataset.delay) || 0;
  var wheel = root.querySelector('[data-spin-wheel]');
  var form = root.querySelector('[data-spin-form]');
  var errorEl = root.querySelector('[data-spin-error]');
  var editor = window.Shopify && window.Shopify.designMode; // в редакторе темы показываем сразу

  // Рисуем сегменты колеса (пути и подписи) из data-атрибутов
  if (wheel) {
    var R = 98, C = 100;
    function pt(a) { var r = (a - 90) * Math.PI / 180; return [C + R * Math.cos(r), C + R * Math.sin(r)]; }
    wheel.querySelectorAll('path[data-arc]').forEach(function (p) {
      var a = p.dataset.arc.split(',').map(Number), s = pt(a[0]), e = pt(a[1]);
      var large = (a[1] - a[0]) > 180 ? 1 : 0;
      p.setAttribute('d', 'M' + C + ' ' + C + ' L' + s[0] + ' ' + s[1] + ' A' + R + ' ' + R + ' 0 ' + large + ' 1 ' + e[0] + ' ' + e[1] + ' Z');
    });
    wheel.querySelectorAll('text[data-angle]').forEach(function (t) {
      var a = Number(t.dataset.angle), p = pt(a);
      var x = C + (p[0] - C) * 0.62, y = C + (p[1] - C) * 0.62;
      t.setAttribute('x', x); t.setAttribute('y', y + 3);
      t.setAttribute('transform', 'rotate(' + a + ' ' + x + ' ' + y + ')');
    });
  }

  var teaser = document.querySelector('[data-spin-teaser]');
  function stored(k) { try { return Number(localStorage.getItem(k)) || 0; } catch (e) { return 0; } }
  function store(k) { try { localStorage.setItem(k, String(Date.now())); } catch (e) { /* ignore */ } }
  function seen() { var t = stored(key); return t && Date.now() - t < days * 864e5; }
  function remember() { store(key); }
  // кнопка «Get 20% off»: прячется крестиком на сутки и навсегда (на days) после ввода email
  function done() { var t = stored(key + '-done'); return t && Date.now() - t < days * 864e5; }
  function teaserHidden() { var t = stored(key + '-teaser'); return t && Date.now() - t < 864e5; }
  function syncTeaser() { if (teaser) teaser.hidden = !root.hidden || done() || teaserHidden(); }
  function open() { root.hidden = false; document.documentElement.style.overflow = 'hidden'; syncTeaser(); }
  function close() { root.hidden = true; document.documentElement.style.overflow = ''; remember(); syncTeaser(); }

  root.querySelectorAll('[data-spin-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.querySelectorAll('[data-spin-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  if (teaser) {
    teaser.querySelector('[data-spin-teaser-close]').addEventListener('click', function () { store(key + '-teaser'); syncTeaser(); });
    if (seen()) syncTeaser();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  if (editor || !seen()) setTimeout(open, editor ? 0 : delay * 1000);

  function showCode() {
    root.querySelector('[data-spin-step="1"]').hidden = true;
    root.querySelector('[data-spin-step="2"]').hidden = false;
    remember(); store(key + '-done');
  }

  // Вернулись после отправки формы (Shopify добавляет ?customer_posted=true) — сразу показываем код.
  // Если по дороге была проверка на бота (/challenge), флаг pending ждёт возврата с неё.
  var pending = stored(key + '-pending') && Date.now() - stored(key + '-pending') < 36e5;
  if (pending && /customer_posted=true/.test(location.search)) {
    try { localStorage.removeItem(key + '-pending'); } catch (e) { /* ignore */ }
    showCode(); open();
  }

  if (form) {
    // Email уходит обычной отправкой формы, а не fetch: фоновый POST на /contact Shopify режет
    // проверкой на бота (403 «Verifying your connection»), а обычную отправку человек проходит.
    form.addEventListener('submit', function (e) {
      if (form.dataset.sending) return; // второй проход — настоящая отправка
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      var btn = form.querySelector('.spin__cta'); if (btn) btn.disabled = true;
      // Крутим 5 полных оборотов + доводим до первого сегмента (выигрыш задан заранее)
      if (wheel) {
        var segs = wheel.querySelectorAll('path[data-arc]').length || 6;
        var target = 360 * 5 + (360 - 360 / segs / 2);
        wheel.classList.add('is-spinning');
        requestAnimationFrame(function () { wheel.style.transform = 'rotate(' + target + 'deg)'; });
      }
      setTimeout(function () {
        store(key + '-pending');
        form.dataset.sending = '1';
        // requestSubmit, а не submit(): Shopify подкладывает токен hCaptcha в обработчике submit
        if (form.requestSubmit) form.requestSubmit(); else HTMLFormElement.prototype.submit.call(form);
      }, 3100);
    });
  }
})();

/* ---------- Cart page (sections/cart.liquid): кнопки ± меняют количество и отправляют форму ---------- */
(function () {
  'use strict';
  var form = document.querySelector('[data-cart-form]');
  if (!form) return;
  form.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      var v = Math.max(0, (Number(input.value) || 0) + Number(b.dataset.qtyStep));
      input.value = v;
      form.submit();
    });
  });
  form.querySelectorAll('.cartp__qty-input').forEach(function (i) { i.addEventListener('change', function () { form.submit(); }); });
})();

/* ---------- CartDrawer (sections/cart-drawer.liquid) ---------- */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !window.fetch) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var sectionId = drawer.dataset.sectionId;
  var errorEl = drawer.querySelector('[data-cart-drawer-error]');

  function open() {
    drawer.hidden = false;
    document.body.classList.add('cdrawer-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('cdrawer-lock');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
  }
  function setError(msg) { if (errorEl) { errorEl.textContent = msg || ''; errorEl.hidden = !msg; } }

  // Перерисовать содержимое из Shopify (Section Rendering API) и обновить счётчик в шапке
  function refresh(andOpen) {
    return fetch(root + '?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var inner = drawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && inner) inner.replaceWith(fresh);
        syncCoupon();
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (andOpen) open();
      });
  }
  function post(url, body) {
    drawer.classList.add('is-busy'); setError('');
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); })
      .then(function () { return refresh(false); })
      .catch(function (e) { setError(e.message); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  // Кто прошёл колесо фортуны — в чекбоксе код NEW20 (20 %), остальным базовый (15 %)
  function spinDone() {
    var spin = document.querySelector('[data-spin]');
    var k = (spin && spin.dataset.key ? spin.dataset.key : 'halvo-spin-v1') + '-done';
    try { return !!Number(localStorage.getItem(k)); } catch (e) { return false; }
  }
  function syncCoupon() {
    var box = drawer.querySelector('[data-cart-coupon]');
    if (!box || !box.dataset.couponWon || !spinDone()) return;
    box.dataset.cartCoupon = box.dataset.couponWon;
    var base = drawer.querySelector('[data-coupon-label]'), won = drawer.querySelector('[data-coupon-label-won]');
    if (base && won) { base.hidden = true; won.hidden = false; }
  }
  syncCoupon();

  // Чекбокс «Apply X% OFF»: ставит или снимает промокод в корзине
  drawer.addEventListener('change', function (e) {
    var box = e.target.closest('[data-cart-coupon]');
    if (!box) return;
    post('cart/update.js', { discount: box.checked ? box.dataset.cartCoupon : '' });
  });

  drawer.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-drawer-close], [data-cart-line], [data-cart-add], [data-cart-offer]');
    if (!t) return;
    if (t.hasAttribute('data-cart-drawer-close')) { close(); return; }
    if (t.hasAttribute('data-cart-line')) { post('cart/change.js', { line: Number(t.dataset.cartLine), quantity: Math.max(0, Number(t.dataset.cartQty)) }); return; }
    if (t.hasAttribute('data-cart-offer')) {
      // «Apply offer»: строка → N банок на плане «раз в N месяцев» (или ежемесячном)
      post('cart/change.js', { line: Number(t.dataset.cartOffer), quantity: Number(t.dataset.qty), selling_plan: Number(t.dataset.plan) });
      return;
    }
    if (t.hasAttribute('data-cart-add')) { post('cart/add.js', { items: [{ id: Number(t.dataset.cartAdd), quantity: 1 }] }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // Иконка корзины в шапке открывает панель вместо перехода на /cart (кроме самой страницы корзины)
  document.querySelectorAll('.cart-badge').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (/\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault(); open();
    });
  });

  window.HalvoCart = { open: open, close: close, refresh: refresh };
})();
